export const toastOptions = {
  duration: 5000,
  style: {
    maxWidth: "340px",
    fontFamily: "Inter",
    // Theme-flipping var (index.css) so toasts follow light/dark mode
    color: "var(--pnai-toast-color)",
    padding: "10px 15px",
    backgroundColor: "oklch(var(--b1))",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    borderRadius: "0.5rem",
    pointerEvents: "auto" as const,
    display: "flex",
    border: "1px solid rgba(7, 104, 253, 0.5)",
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    cursor: "pointer",
  },
  success: {
    iconTheme: {
      primary: "#0768fd",
      secondary: "#fff",
    },
  },
  loading: {
    iconTheme: {
      primary: "#0768fd",
      secondary: "#fff",
    },
  },
};
